import React, { Component } from 'react';
import PropTypes from 'prop-types';


import '../Filter.css';

class FilterComponent extends Component {
  static get propTypes() {
    return {
      setDisplayFilter: PropTypes.func,
      filterKey: PropTypes.string,
      filterValue: PropTypes.any,
      requiredFilterKey: PropTypes.string
    };
  }

  componentWillReceiveProps(props) {
    if (this.state.filterValue !== props.filterValue) {
      this.setState({ filterValue: props.filterValue });
    }
  }

  renderFilterBody() {
    throw new Error('Not implemented');
  }

  renderFilterButtons() {
    return (
      <div className="FilterComponent-buttonRow">
        <input type="button" onClick={() => this.onCancel()} className="btn btn-cancel cancel-filter" value="CANCEL" />
        <input type="button" onClick={() => this.onApplyFilter()} className="btn btn-primary apply-filter" value="APPLY" />
      </div>
    );
  }

  onApplyFilter() {
    this.onFilter();
    this.onCancel();
  }

  onCancel() {
    const { setDisplayFilter } = this.props;
    setDisplayFilter(false);
  }

  onFilter() {
    return null;
  }

  render() {
    const { filterKey, requiredFilterKey } = this.props;
    if (filterKey !== requiredFilterKey) {
      return null;
    }

    return (
      <div className="FilterComponent">
        { this.renderFilterBody() }
        { this.renderFilterButtons() }
      </div>
    );
  }
}

export default FilterComponent;




// WEBPACK FOOTER //
// ./src/filter/filterTypes/FilterComponent.js